import { GetComponentProps, loadjs } from 'topwrite';
import { useEffect } from 'react';
import useConfig from '@@/use-config';

export default function Activate({ children }: GetComponentProps<'activate'>) {
    const config = useConfig();
    const id = config.getValue('siteId');

    useEffect(() => {
        if (id) {
            loadjs('https://www.topthink.com/assistant/js', {
                success() {
                    window.tas.init(id, {
                        appearance: {
                            button: {
                                hidden: true
                            }
                        },
                        doc: {
                            enable: false,
                        }
                    });
                }
            });
        }
    }, []);

    return children;
}
